import React from "react";
import { Link } from "react-router-dom";

class Welcome extends React.Component {
  render() {
    return (
      <div className="container animated fadeIn">
        <div>
          <br />
          <br />
          <br />
        </div>
        <div className="title has-text-centered">
          Welcome {this.props.user.first_name},
        </div>
        <div className="">
          <div className="columns">
            <div className="column is-3"></div>
            <div className="column is-6">
              <div className="card bordered-card is-shadowless">
                <div className="card-content">
                  <div className="has-text-centered is-size-4">
                    <span className="zmdi zmdi-play mr-2"></span>
                    <span>Start Something Different ...</span>
                  </div>
                  <div className="mt-4 has-text-centered">
                    <Link to="/myshop/create/">
                      <button className="button is-link">
                        <span className="zmdi zmdi-plus mr-2"></span>
                        <span>Add a Business</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Welcome;
